<template>
  <div class="dropdown-container connectionNotifications">
    <div class="title">
      <div>{{ meta.title }}</div>
    </div>
    <div v-if="!hasLoadedOnce && !allLoaded && !connectRequests.length" class="info-text">{{ meta.loading }}</div>
    <div v-else-if="hasLoadedOnce && !connectRequests.length" class="info-text">{{ meta.empty }}</div>
    <div v-else class="item-container">
      <div v-for="(request, index) in connectRequests" :key="index" class="dropdown-item">
        <div class="details">
          <a :href="`/profile/${request.UID}`">
            <ik-image loading="lazy" :transformation="[{ height: 500, width: 500 }]" v-if="request.url" :src="request.url" class="image" />
            <div v-else class="image smallBorder">
              <IconBase icon-name="profile" iconColor="#333" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"><IconProfileImg /></IconBase>
            </div>
          </a>
          <a :href="`/profile/${request.UID}`" class="displayName">{{ request.name }}</a>
        </div>
        <div class="accept-request" @click="handleRequest(request, 'accept')">Accept</div>
        <div class="delete-item" @click="handleRequest(request, 'reject')">
          <IconBase icon-name="trash" iconColor="#444" viewBox="-57 0 512 512" width="100%" height="100%" strokeWidth="0px"><IconTrash /></IconBase>
        </div>
        <!-- <div class="delete-actions">
          <div>Cancel</div>
          <div>Delete</div>
        </div> -->
      </div>
    </div>
    <div class="infinite-container">
      <infinite-loading @infinite="loadMoreConnectRequests" spinner="spiral">
        <template v-slot:spinner>
          {{}}
        </template>
        <template v-slot:no-more>
          {{}}
        </template>
        <template v-slot:no-results>
          {{}}
        </template>
        <template v-slot:error> gg </template>
      </infinite-loading>
    </div>
    <!-- <input
      class="setting-input"
      placeholder="Write 300 words, organize inbox, read 20 pages, etc."
      v-model="task"
    />
    <div
      @click="createNewTask"
      class="dropdown-item new"
      :disabled="gettingConnectRequests"
    >
      {{ gettingConnectRequests ? "Adding..." : "Add task" }}
    </div> -->
    <div class="expand">
      <div @click="toProfile" class="expand-button">{{ meta.toProfile }}</div>
    </div>
  </div>
</template>

<!-- When user does have rooms, there can be a quick entry by displaying some of the rooms as some sort of circles on a separate row, which have an image or letter & it is scrollable, maybe expandable, it is still under 'My rooms' title.-->

<script>
import InfiniteLoading from "vue-infinite-loading";

import IconBase from "@/components/IconBase";
import IconTrash from "@/components/SVG/IconTrash";
import IconProfileImg from "@/components/SVG/IconProfileImg";

import profileAPIService from "@/api/profileAPIService";

const REQUEST_LIMIT = 4;

export default {
  name: "ConnectionNotifications",
  components: {
    IconBase,
    IconTrash,
    IconProfileImg,
    InfiniteLoading,
  },
  props: {
    newRequestsExist: Boolean,
    connectRequests: Array,
    userID: {
      type: String,
      required: true,
    },
    allLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasLoadedOnce: false,
      handlingRequest: false,
      fetchError: false,
      oldMeta: {
        title: "Connect requests",
        loading: "Loading requests...",
        empty: "You have no requests.",
        toProfile: "Manage all in profile",
        load: "Load more",
        allLoaded: "No more to load",
      },
      meta: {
        title: "Connect requests",
        loading: "Loading requests...",
        empty: "You have no requests.",
        toProfile: "Manage all in profile",
        load: "Load more",
        allLoaded: "No more to load",
      },
    };
  },
  methods: {
    areAllLoaded(loadedCount) {
      return this.allLoaded ? true /* if all were loaded previously, we cannot get older requests */ : loadedCount < REQUEST_LIMIT;
    },
    async loadMoreConnectRequests($state) {
      if (this.allLoaded && !this.newRequestsExist && $state) {
        console.log("CLOSED, because all Loaded");
        $state.complete();
      } else {
        let result = null;
        if (this.newRequestsExist) {
          console.log("newRequestsExisted");
          result = await profileAPIService.getConnectRequests(this.userID, REQUEST_LIMIT, 0, false);
        } else {
          result = await profileAPIService.getConnectRequests(this.userID, REQUEST_LIMIT, this.connectRequests.length, false);
        }
        console.log("@loadMoreConnectRequests the result: ", result);
        if (result !== null && result.requests) {
          this.$emit("connectionsRequested", result.requests);
          /* return whether all are loaded */
          this.$emit("areAllLoaded", this.areAllLoaded(result.requests.length));
        } else {
          console.error("@loadMoreConnectRequests error");
        }
        if ($state) {
          $state.loaded();
        }
      }
      this.hasLoadedOnce = true;
    },
    async handleRequest(request, type) {
      if (this.handlingRequest) return;
      console.log("request: ", request, "type: ", type);
      this.handlingRequest = true;
      let result = null;
      if (type === "accept") {
        console.log("accepting", request.UID);
        result = await profileAPIService.acceptConnectRequest(request.CID, this.userID, request.UID);
      } else if (type === "reject") {
        result = await profileAPIService.rejectConnectRequest(request.CID, this.userID, request.UID);
      }
      if (result !== null) {
        console.log("NOICE!, result:", result);
        this.$emit("removeRequest", request);
        this.$emit("setAsSeen");
      } else {
        console.log("RIP");
        console.error("@handleRequest");
      }
      this.handlingRequest = false;
    },
    toProfile() {
      /* this.$router.push(`/profile/${this.userID}/received-requests`); */
      window.location = `/profile/${this.userID}/received-requests`;
    },
  },
  watch: {
    newRequestsExist: function (newState) {
      if (newState) {
        console.log("LOADING MORE CONNETIONS because was open and new requests exist");
        this.loadMoreConnectRequests();
      }
    },
  },
};
</script>

<style scoped>
@import "./styles/Dropdown.css";

.connectionNotifications {
  left: calc((-241px) / 2) !important;
}

.accept-request {
  position: absolute;
  height: 16px;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0px;
  z-index: 50;
  border-radius: 360px;
  background-color: white;
  border: 1px solid #eaeaea;
  padding: 4px 10px;
  font-size: 15px;
}

.accept-request:hover {
  background-color: #f3f3f3;
}
.infinite-status-prompt {
  padding: 0px !important;
}
</style>
